import { useSearchParams } from "react-router";
import { useSellarUser } from "./useSellarUser.shared";

const validatePostcode = (postcodeParam: string) => {
  return new RegExp("[A-Za-z]{1,2}\\d[A-Za-z\\d]?\\s*\\d[A-Za-z]{2}").test(
    postcodeParam,
  );
};
export const useSearchParamsPostcodeCheck = () => {
  const [searchParams] = useSearchParams();
  const { user } = useSellarUser();
  const postcodeParams = searchParams.get("postcode");
  if (user || !postcodeParams)
    return {
      isValid: false,
      postcode: null,
    };

  return {
    isValid: validatePostcode(postcodeParams),
    postcode: postcodeParams,
  };
};
